import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { calculateFilterColor } from '@/utils/Common/ListingUtils';
import useAppliedFilterSlider from '@/hooks/useAppliedFilterSlider';

const AppliedFilters = ({
  breadcrumbs,
  clearFiltersLabel,
  onClearFilters,
  onRemoveFilter,
}) => {
  const { t } = useTranslation();
  const [wrapperRef, hasBreadcrumb] = useAppliedFilterSlider(breadcrumbs, {
    resistanceRatio: 0,
    touchStartPreventDefault: false,
  });
  if (!hasBreadcrumb) return null;
  return (
    <div className='ken-plp__applied-filters__wrapper'>
      <div className='ken-plp__applied-filters ken-wrapper--big-grid'>
        <div ref={wrapperRef} className='swiper-container'>
          <div className='swiper-wrapper'>
            {breadcrumbs.map(breadcrumb => {
              const { name } = calculateFilterColor(breadcrumb.facetValueName);
              return (
                <span
                  key={breadcrumb.facetValueCode}
                  className='swiper-slide ken-plp__applied-filters__slide'
                >
                  <button
                    type='button'
                    onClick={() => onRemoveFilter(breadcrumb.removeQuery)}
                  >
                    {breadcrumb.facetCode === 'percentageDiscountValue'
                      ? t('listing:filter.option.discount.range', {
                          range: name,
                        })
                      : name}
                    <i className='ken-icon ken-icon--close' />
                  </button>
                </span>
              );
            })}
            <span className='swiper-slide ken-plp__applied-filters__slide'>
              <button
                type='button'
                className='ken-button--link --no-background'
                onClick={onClearFilters}
              >
                {clearFiltersLabel}
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

AppliedFilters.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape()),
  clearFiltersLabel: PropTypes.string,
  onClearFilters: PropTypes.func,
  onRemoveFilter: PropTypes.func,
};

AppliedFilters.defaultProps = {
  breadcrumbs: [],
  clearFiltersLabel: 'Clear all',
  onClearFilters: null,
  onRemoveFilter: null,
};

export default AppliedFilters;
